import { Box, Avatar, Typography, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import { tokens } from "../../../../../theme";

interface User {
  id?: string;
  first_name: string;
  last_name: string;
  email: string;
  profile_picture_url?: string;
}

interface Props {
  assignees: User[];
}

export const TableRowAssignees: React.FC<Props> = ({ assignees }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const assignee = assignees[0];

  if (!assignee) {
    return (
      <Typography
        sx={{
          mt: 2,
          fontSize: "13px",
          color: colors.grey[400],
        }}
      >
        No assignee
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mt: 2,
      }}
    >
      <Avatar
        src={assignee.profile_picture_url || undefined}
        alt={assignee.first_name}
        sx={{
          width: 25,
          height: 25,
          fontSize: "12px",
        }}
      >
        {assignee.first_name.charAt(0).toUpperCase()}
      </Avatar>

      <Typography
        sx={{
          fontSize: "13px",
          color: colors.primary[700],
        }}
      >
        {`${assignee.first_name} ${assignee.last_name ?? ""}`}
      </Typography>
    </Box>
  );
};

TableRowAssignees.propTypes = {
  assignees: PropTypes.arrayOf(PropTypes.object).isRequired,
};